import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-bloc-ami',
  templateUrl: './home-bloc-ami.component.html',
  styleUrls: ['./home-bloc-ami.component.scss']
})
export class HomeBlocAmiComponent {
@Input() showRejoindre :any = 'true';

  onNavigateRejoindre() {
    window.open(
      'https://thedoorman-recrute.fr/',
      '_blank',
      'noopener,noreferrer'
    );
  }
  
}
